export const actions = [
  { id: 1, name: 'Products', url: 'import-products', colName: 'products' },
  // { id: 2, name: 'Translate Products', url: 'import-translate', colName: 'translate_products' },
  // { id: 3, name: 'Price', url: 'import-pricing', colName: 'products_price' },
];
